'use client'

import { Checkbox, TextField } from '@graftcode/design-system'

import { WIZARD_COPY } from '../../const'
import type { TypesSectionProps } from '../../types'

import styles from './TypesSection.module.scss'

export function TypesSection({
  availableTypes,
  selectedTypes,
  graftableMethodsOnly,
  graftableTypesOnly,
  typePatternsText,
  onToggleType,
  onTypePatternsChange,
}: TypesSectionProps) {
  const { types: copy, sections } = WIZARD_COPY
  const controlsDisabled = graftableMethodsOnly || graftableTypesOnly

  return (
    <section className={styles.section} aria-labelledby="graft-filter-wizard-types">
      <h3 id="graft-filter-wizard-types" className={styles.sectionTitle}>
        {sections.types}
      </h3>

      <div className={styles.typeList}>
        {availableTypes.map((type) => {
          const checked = graftableMethodsOnly
            ? true
            : graftableTypesOnly
              ? type.graftable
              : selectedTypes.includes(type.fqn)

          return (
            <label key={type.fqn} className={styles.typeOption}>
              <Checkbox
                checked={checked}
                disabled={controlsDisabled}
                onChange={(value) => onToggleType(type.fqn, value === true)}
              />
              <span className={styles.typeLabel}>
                <code>{type.fqn}</code>
                {!type.graftable && <span className={styles.typeWarning}>{copy.typeWarning}</span>}
              </span>
            </label>
          )
        })}
      </div>
      <TextField
        label={copy.patternsLabel}
        placeholder={copy.patternsPlaceholder}
        helperText={copy.patternsHelper}
        value={typePatternsText}
        disabled={controlsDisabled}
        onChange={(event) => onTypePatternsChange(event.target.value)}
      />
    </section>
  )
}
